export default __webpack_public_path__ + "static/media/events-nav.b625244e.svg";